<template>
  <div style="padding: 0 15px">
    <!-- 工具栏 -->
    <div class="filter-container">
      <el-button v-if="isAdmin_Vip" class="filter-item" size="small" icon="el-icon-circle-plus-outline" type="primary" @click="yonghuquanxianbtn">添加权限</el-button>
      <el-button v-if="isAdmin_Vip" class="filter-item" size="small" icon="el-icon-delete" type="danger" @click="piliangshanchuquanxian">批量删除</el-button>
      <el-input class="filter-item" size="small" v-model="search" clearable placeholder="名称模糊查询" style="width: 220px"></el-input>
      <el-select class="filter-item" v-model="leixingvalue" size="small" placeholder>
        <el-option label="全部权限" value="-1"></el-option>
        <el-option v-for="item in purviewOptions" :key="item.id" :label="item.name" :value="item.id"></el-option>
        <!-- <el-option label="渠道" value="4"></el-option> -->
      </el-select>
      <el-button class="filter-item" type="primary" size="small" @click="chaxunbtn">查询</el-button>
    </div>

    <!-- table 列表-->
    <el-table class="grayTableTile" size="mini" v-loading="listLoading" ref="multipleTable" :data="tableData" border style="width: 100%" @sort-change="handleAgeSortChange" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="permissionValue" label="权限名称" sortable='custom'></el-table-column>
      <el-table-column prop="name" label="显示名称" sortable='custom'></el-table-column>
      <el-table-column prop="addTime" label="创建时间" sortable='custom'></el-table-column>
      <el-table-column prop="type" label="策略类型" sortable='custom'>
        <template slot-scope="scope">
          <span>{{ scope.row.type | yinyongleixing }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="type" label="权限类型" sortable='custom'>
        <template slot-scope="scope">
          <span>{{ scope.row.status | statusType }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="" label="操作" width="150">
        <template slot-scope="scope">
          <div class="bdc-table-op-cell">
            <el-button type="text" class="bdc-table-op-danger" :disabled="!scope.row.del && !isAdmin_Vip" @click="quanxianshanchu(scope.row)">删除</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <pagination v-show="total>0" :total="total" :page.sync="listQuery.pageNo" :limit.sync="listQuery.pageSize" style="margin-top:0;" @pagination="getList" />

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { roledoRemovePermission, pagePermissionByRoleId } from '@Sys~/api/sys'
import { arrSlice, sortKeys } from '@/filters'

export default {
  components: { Pagination },
  data() {
    return {
      isAdmin_Vip: this.$store.getters.roles.indexOf('admin') > -1 || this.$store.getters.roles.indexOf('vip') > -1,
      search: '',
      leixingvalue: "-1",
      purviewOptions:process.env.VUE_APP_PROJECT_TYPE == 'ads' ? [{id:2, name:'菜单'},{id:5, name:'媒体'},{id:6, name:'监测'},{id:7, name:'指标'},{id:8, name:'用户来源'}] : process.env.VUE_APP_PROJECT_TYPE == 'file' ? [{id:2, name:'菜单'},{id:1, name:'功能点'},{id:9, name:'部门'},{id:10, name:'外包商'}] : [{id:2, name:'菜单'},{id:4, name:'渠道'},{id:12, name:'国家维度'}],
      listLoading: false,
      originalCaseTable: [],// 排序原始数据
      caseTable: [], // 存放后端一次性返回的所有数据
      handCaseTable: [], // 存放处理假分页后的数据(等距切割)
      tableData: [], // 切割后页面应展示的数据
      total: 0,
      listQuery: {
        pageNo: 1,
        pageSize: 10
      },

      userInfo: {}, // 详情

      multipleSelection: [], // 选中
    }
  },

  filters: {
    yinyongleixing(value) {
      if (value == "0") {
        return "系统权限";
      } else if (value == "1") {
        return "自定义权限";
      }
    },

    statusType(type) {
      const typeMap = {
        2 : '菜单',
        4 : '渠道',
        5 : '媒体',
        6 : '监测',
        7 : '指标',
        8 : '用户来源',
        12 :'国家维度'
      }
      return typeMap [type]
    }
  },

  methods: {
    init(row, list) {
      this.userInfo = row
      this.search = ''
      this.listLoading = false
      this.tableData = []
      this.total = 0
      this.listQuery = {
        pageNo: 1,
        pageSize: 10
      }

      this.multipleSelection = []

      this.getList();
    },
    getList() {
      var datas = {
        id: this.userInfo.id,//角色Id
        type: this.leixingvalue,//权限点分类 2:菜单,4:渠道,
        queryWord: this.search,//模糊词
        pageNo: this.listQuery.pageNo,//
        pageSize: this.listQuery.pageSize//
      }
      this.listLoading = true
      pagePermissionByRoleId(datas).then(response => {
        if (response.code == 1) {
          this.tableData = response.data.result
          this.total = response.data.totalCount

          this.$refs.multipleTable.clearSelection();
        }
        this.listLoading = false
      })
    },
    chaxunbtn(){
      this.listQuery.pageNo = 1;
      this.getList();
    },
    // 排序
    handleAgeSortChange(e) {
      if (e.order) {
        const order = e.order == 'descending' ? false : true
        this.caseTable.sort(sortKeys(e.prop, order))
      } else {
        this.caseTable = JSON.parse(JSON.stringify(this.originalCaseTable))
      }
    },

    // 选中
    handleSelectionChange(val) {
      this.multipleSelection = val
    },

    // 添加用户权限
    yonghuquanxianbtn() {
      this.$emit('handleAddRoles')
    },

    // 批量删除
    piliangshanchuquanxian() {
      if (this.multipleSelection.length > 0) {
        const ids = []
        this.multipleSelection.forEach(m => {
          ids.push(m.id)
        });

        const data = {
          roleId: [this.userInfo.id],
          permissionIds: ids
        }
        this.handleDelete(data)
      } else {
        this.$message({
          message: "请先选择要删除的用户权限",
          type: "error"
        });
      }

    },

    // 单个删除
    quanxianshanchu(row) {
      const data = {
        roleId: [this.userInfo.id],
        permissionIds: [row.id]
      }
      this.handleDelete(data, row)
    },

    // 操作删除
    handleDelete(data, row) {
      this.$confirm(row ? '确认删除用户权限： "' + row.name + '" 吗？' : '确认删除所选权限吗？').then(_ => {
        roledoRemovePermission(data).then(response => {
          if (response.code == 1) {
            this.$message({
              message: "删除成功",
              type: "success"
            });
            this.$emit('getAgainList')
          }
        });
      }).catch(_ => { });
    }
  }
}
</script>